/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentTemplateDto } from '../../models/create-document-template-dto';
import { DocumentTemplateDto } from '../../models/document-template-dto';

export interface DocumentTemplateControllerCreateDocument$Params {
  centerId: string;
      body: CreateDocumentTemplateDto
}

export function documentTemplateControllerCreateDocument(http: HttpClient, rootUrl: string, params: DocumentTemplateControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, documentTemplateControllerCreateDocument.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentTemplateDto>;
    })
  );
}

documentTemplateControllerCreateDocument.PATH = '/api/document-template';
